var _path, _g, _path2, _path3, _path4, _g2, _path5, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuthenticateShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 58,
    viewBox: "0 0 70 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7086_3786",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 20,
    width: 68,
    height: 38
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6792 20.6113H68.2773V57.6522H1.6792V20.6113Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7086_3786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.2015 57.6515H1.79785V20.6582H68.2015V57.6515Z",
    fill: "#8D7CBC"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.8728 47.576H46.5101V56.3237H66.8728V47.576ZM23.4902 47.576H3.12646V56.3237H23.4913L23.4902 47.576ZM43.6734 45.6427H43.4811C43.2109 45.6427 42.9915 45.4223 42.9915 45.1521V44.9587H37.6002V45.1521C37.6002 45.4223 37.3808 45.6427 37.1107 45.6427H36.9172V53.4427H37.1107C37.3808 53.4427 37.6002 53.6621 37.6002 53.9333V54.1268H42.9915V53.9333C42.9915 53.6621 43.2109 53.4427 43.4811 53.4427H43.6734V45.6427ZM45.182 32.0721V56.3237H35.4097V32.0721H45.182ZM42.6241 45.3455H37.9655C37.8909 45.6751 37.6326 45.9345 37.3041 46.009V53.0753C37.6326 53.1488 37.8909 53.4103 37.9655 53.7377H42.6241C42.6987 53.4103 42.9591 53.1488 43.2866 53.0753V46.009C42.9591 45.9345 42.6987 45.6751 42.6241 45.3455ZM33.0831 45.6427H32.8897C32.6195 45.6427 32.4001 45.4223 32.4001 45.1521V44.9587H27.0109V45.1521C27.0109 45.4223 26.7905 45.6427 26.5203 45.6427H26.3258V53.4427H26.5203C26.7905 53.4427 27.0109 53.6621 27.0109 53.9333V54.1268H32.4001V53.9333C32.4001 53.6621 32.6195 53.4427 32.8897 53.4427H33.0831V45.6427ZM34.5906 32.0721V56.3237H24.8183V32.0721H34.5906ZM32.0349 45.3455H27.3762C27.3016 45.6751 27.0423 45.9345 26.7138 46.009V53.0753C27.0423 53.1488 27.3016 53.4103 27.3762 53.7377H32.0349C32.1083 53.4103 32.3677 53.1488 32.6962 53.0753V46.009C32.3677 45.9345 32.1083 45.6751 32.0349 45.3455ZM65.8256 17.7073H4.17469V0.00108063L65.8267 0V17.7062",
    fill: "#83CDB3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2846 7.47521V3.57088C63.2234 3.57088 62.3643 2.7107 62.3643 1.64844H7.63601C7.63493 2.7107 6.77581 3.57088 5.71678 3.57088V7.47521C6.77581 7.47521 7.63493 8.3354 7.63493 9.39766H62.3643C62.3643 8.3354 63.2234 7.47521 64.2835 7.47521H64.2846ZM43.6734 33.405H36.9172V42.4251H43.6734V33.405ZM33.0831 33.405H26.3258V42.4251H33.0831V33.405ZM66.8728 21.9892H46.5101V30.738H66.8728V21.9892ZM66.8728 32.0683H46.5101V46.2937H66.8728V32.0683ZM45.182 21.9892H24.8183V30.738H45.182V21.9892ZM23.4902 21.9892H3.12646V30.738H23.4913L23.4902 21.9892ZM23.4902 46.2937H3.12646V32.0683H23.4913V46.2937",
    fill: "#FEF6E2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_7086_3786",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 20,
    width: 70,
    height: 5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.3301H70V24.3457H0V20.3301Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_7086_3786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9713 20.4219H23.4176C23.4176 22.5821 25.165 24.3327 27.3198 24.3327C29.1407 24.3327 30.6677 23.0802 31.0967 21.389C31.5279 23.0802 33.0527 24.3327 34.8746 24.3327C37.0295 24.3327 38.7769 22.5821 38.7769 20.4219H30.9713ZM42.6802 24.3327C44.835 24.3327 46.5824 22.5821 46.5824 20.4219H38.7769C38.7769 22.5821 40.5243 24.3327 42.6802 24.3327ZM50.4857 24.3327C52.6405 24.3327 54.3879 22.5821 54.3879 20.4219H46.5824C46.5824 22.5821 48.3298 24.3327 50.4857 24.3327ZM62.1934 20.4219C62.1934 22.5821 63.9408 24.3327 66.0956 24.3327C68.2515 24.3327 69.9989 22.5821 69.9989 20.4219H62.1934ZM58.2901 24.3327C60.446 24.3327 62.1934 22.5821 62.1934 20.4219H54.3879C54.3879 22.5821 56.1353 24.3327 58.2901 24.3327ZM19.5143 24.3327C21.6702 24.3327 23.4176 22.5821 23.4176 20.4219H15.6121C15.6121 22.5821 17.3595 24.3327 19.5143 24.3327ZM11.7088 24.3327C13.8647 24.3327 15.6121 22.5821 15.6121 20.4219H7.80551C7.80551 22.5821 9.55292 24.3327 11.7088 24.3327ZM0 20.4219H7.80551C7.80551 22.5821 6.05919 24.3327 3.9033 24.3327C1.74741 24.3327 0 22.5821 0 20.4219Z",
    fill: "#F79B5E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_7086_3786",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 10,
    width: 70,
    height: 37
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 10.9375H70V46.4071H0V10.9375Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_7086_3786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3256 36.8882L30.4494 33.4075H33.0829V35.5352L26.3256 41.2421V36.8882ZM70 20.4183H0L4.17454 10.9746H65.8265L70 20.4183ZM47.7203 23.1771L46.51 24.1994V21.9927H46.9131C47.1086 22.4369 47.3831 22.8378 47.7203 23.1771ZM15.1842 46.2962L23.49 39.2829V43.6368L20.3389 46.2962H15.1842ZM45.1819 23.4192V25.3211L38.7628 30.7405H33.607L41.4407 24.1259C41.8297 24.2567 42.2468 24.3291 42.6802 24.3291C43.6322 24.3291 44.5054 23.9876 45.1819 23.4192ZM10.1786 46.2962H3.12631V44.7239L18.1116 32.0718H23.4911V35.0576L10.1786 46.2962ZM36.7971 23.8223L28.6026 30.7405H24.8181V26.4082L27.282 24.328C27.2939 24.328 27.3069 24.3291 27.3198 24.3291C28.9149 24.3291 30.2841 23.3673 30.8892 21.9927H31.3074C31.9104 23.3673 33.2796 24.3291 34.8746 24.3291C35.5727 24.3291 36.2287 24.1443 36.7971 23.8223ZM37.8972 22.8929L38.9627 21.9927H38.4483C38.3035 22.318 38.1198 22.6206 37.8972 22.8929ZM19.6872 30.7405L23.49 27.5299V30.7405H19.6872Z",
    fill: "#FBCF71"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthenticateShop);
export default __webpack_public_path__ + "static/media/authenticate_shop.3bf985aa6695dff34cbe7bc05b7abc9d.svg";
export { ForwardRef as ReactComponent };